import axios from '@/libs/axiosInstance';
import { getTikTokOAuthRedirect } from '@/services/tiktok-service';
import { create } from 'zustand';

/** OAuth flow only: whether the integration is live is the server's answer, read from the integrations query. */
interface TikTokState {
  isLoading: boolean;
  disconnect: (id: string) => Promise<void>;
  initiateOAuthFlow: () => Promise<void>;
}

export const useTikTokStore = create<TikTokState>((set) => ({
  isLoading: false,

  disconnect: async (id) => {
    set({ isLoading: true });
    try {
      await axios.delete('/dashboard/integrations/' + id);
    } catch (error) {
      console.error('Failed to disconnect TikTok:', error);
      throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  initiateOAuthFlow: async () => {
    set({ isLoading: true });
    try {
      const oauthResponse = await getTikTokOAuthRedirect();
      window.location.href = oauthResponse.redirectUrl;
    } catch (error) {
      console.error('Failed to initiate TikTok OAuth flow:', error);
      set({ isLoading: false });
      throw error;
    }
  },
}));
